(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8927],{

/***/ 52970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Hide; },
/* harmony export */   "di": function() { return /* binding */ Show; },
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47386);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80190);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37687);






var useSafeLayoutEffect = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * React hook that tracks state of a CSS media query
 *
 * @param query the media query to match
 */

function useMediaQuery(query) {
  var env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  var queries = Array.isArray(query) ? query : [query];
  var isSupported = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU && "matchMedia" in env.window;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(queries.map(function (query) {
    return isSupported ? !!env.window.matchMedia(query).matches : false;
  })),
      matches = _React$useState[0],
      setMatches = _React$useState[1];

  useSafeLayoutEffect(function () {
    if (!isSupported) return undefined;
    var mediaQueryList = queries.map(function (query) {
      return env.window.matchMedia(query);
    });
    var listenerList = mediaQueryList.map(function () {
      var listener = function listener() {
        var isEqual = function isEqual(prev, curr) {
          return prev.length === curr.length && prev.every(function (elem, idx) {
            return elem === curr[idx];
          });
        };

        var currentMatches = mediaQueryList.map(function (mediaQuery) {
          return mediaQuery.matches;
        });

        if (!isEqual(matches, currentMatches)) {
          setMatches(currentMatches);
        }
      };

      env.window.addEventListener("resize", listener);
      return listener;
    });
    return function () {
      mediaQueryList.forEach(function (_, index) {
        env.window.removeEventListener("resize", listenerList[index]);
      });
    };
  }, [query]);
  return matches;
}

/**
 * Visibility
 *
 * React component to control the visibility of its
 * children based on the current breakpoint
 */
var Visibility = function Visibility(props) {
  var breakpoint = props.breakpoint,
      hide = props.hide,
      children = props.children;

  var _useMediaQuery = useMediaQuery(breakpoint),
      show = _useMediaQuery[0];

  var isVisible = hide ? !show : show;
  var rendered = isVisible ? children : null;
  return rendered;
};

var Hide = function Hide(props) {
  var children = props.children;
  var query = useQuery(props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true
  }, children);
};

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .__DEV__ */ .Ts) {
  Hide.displayName = "Hide";
}

var Show = function Show(props) {
  var children = props.children;
  var query = useQuery(props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query
  }, children);
};

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .__DEV__ */ .Ts) {
  Show.displayName = "Show";
}

var getBreakpoint = function getBreakpoint(theme, value) {
  return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .memoizedGet */ .Wf)(theme, "breakpoints." + value, value);
};

function useQuery(props) {
  var _props$breakpoint = props.breakpoint,
      breakpoint = _props$breakpoint === void 0 ? "" : _props$breakpoint,
      below = props.below,
      above = props.above;
  var theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
  var bpBelow = getBreakpoint(theme, below);
  var bpAbove = getBreakpoint(theme, above);
  var query = breakpoint;

  if (bpBelow) {
    query = "(max-width: " + bpBelow + ")";
  } else if (bpAbove) {
    query = "(min-width: " + bpAbove + ")";
  }

  return query;
}

/**
 * React hook used to get the user's animation preference.
 */

function usePrefersReducedMotion() {
  var _useMediaQuery = useMediaQuery("(prefers-reduced-motion: reduce)"),
      prefersReducedMotion = _useMediaQuery[0];

  return prefersReducedMotion;
}
/**
 * React hook for getting the user's color mode preference.
 */

function useColorModePreference() {
  var _useMediaQuery2 = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"]),
      isLight = _useMediaQuery2[0],
      isDark = _useMediaQuery2[1];

  if (isLight) return "light";
  if (isDark) return "dark";
  return undefined;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createMediaQueries(breakpoints) {
  return Object.entries(breakpoints) // sort css units in ascending order to ensure media queries are generated
  // in the correct order and reference to each other correctly aswell
  .sort(function (a, b) {
    return Number.parseInt(a[1], 10) > Number.parseInt(b[1], 10) ? 1 : -1;
  }).map(function (_ref, index, arr) {
    var breakpoint = _ref[0],
        minWidth = _ref[1];
    // given a following breakpoint
    var next = arr[index + 1]; // this breakpoint must end prior the threshold of the next

    var maxWidth = next ? next[1] : undefined;
    var query = createMediaQueryString(minWidth, maxWidth);
    return {
      minWidth: minWidth,
      maxWidth: maxWidth,
      breakpoint: breakpoint,
      query: query
    };
  });
}
/**
 * Create a media query string from the breakpoints,
 * using a combination of `min-width` and `max-width`.
 */

function createMediaQueryString(minWidth, maxWidth) {
  var hasMinWidth = parseInt(minWidth, 10) >= 0;

  if (!hasMinWidth && !maxWidth) {
    return "";
  }

  var query = "(min-width: " + toMediaString(minWidth) + ")";

  if (!maxWidth) {
    return query;
  }

  if (query) {
    query += " and ";
  }

  query += "(max-width: " + toMediaString(subtract(maxWidth)) + ")";
  return query;
}

var measurementRegex = /([0-9]+\.?[0-9]*)/;

var calculateMeasurement = function calculateMeasurement(value, modifier) {
  if (typeof value === "number") {
    return "" + (value + modifier);
  }

  return value.replace(measurementRegex, function (match) {
    return "" + (parseFloat(match) + modifier);
  });
};
/**
 * 0.01 and 0.1 are too small of a difference for `px` breakpoint values
 *
 * @see https://github.com/chakra-ui/chakra-ui/issues/2188#issuecomment-712774785
 */


function subtract(value) {
  return calculateMeasurement(value, value.endsWith("px") ? -1 : -0.01);
}
/**
 * Convert media query value to string
 */


function toMediaString(value) {
  return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(value) ? value + "px" : value;
}

var _excluded = ["query"],
    _excluded2 = ["query"];

/**
 * React hook used to get the current responsive media breakpoint.
 *
 * @param defaultBreakpoint default breakpoint name
 * (in non-window environments like SSR)
 *
 * For SSR, you can use a package like [is-mobile](https://github.com/kaimallea/isMobile)
 * to get the default breakpoint value from the user-agent
 */
function useBreakpoint(defaultBreakpoint) {
  var _useTheme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)(),
      breakpoints = _useTheme.breakpoints;

  var env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  var mediaQueries = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return createMediaQueries(_extends({
      base: "0px"
    }, breakpoints));
  }, [breakpoints]);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(function () {
    if (!defaultBreakpoint) {
      return undefined;
    }

    var mediaQuery = mediaQueries.find(function (_ref) {
      var breakpoint = _ref.breakpoint;
      return breakpoint === defaultBreakpoint;
    });

    if (mediaQuery) {
      mediaQuery.query;
          var breakpoint = _objectWithoutPropertiesLoose(mediaQuery, _excluded);

      return breakpoint;
    }

    return undefined;
  }),
      currentBreakpoint = _React$useState[0],
      setCurrentBreakpoint = _React$useState[1];

  var current = currentBreakpoint == null ? void 0 : currentBreakpoint.breakpoint;
  var update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (query, breakpoint) {
    if (query.matches && current !== breakpoint.breakpoint) {
      setCurrentBreakpoint(breakpoint);
    }
  }, [current]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var listeners = new Set();
    mediaQueries.forEach(function (_ref2) {
      var query = _ref2.query,
          breakpoint = _objectWithoutPropertiesLoose(_ref2, _excluded2);

      var mediaQuery = env.window.matchMedia(query); // trigger an initial update to determine media query

      update(mediaQuery, breakpoint);

      var handleChange = function handleChange() {
        update(mediaQuery, breakpoint);
      }; // add media query-listener


      mediaQuery.addListener(handleChange); // push the media query list handleChange
      // so we can use it to remove Listener

      listeners.add({
        mediaQuery: mediaQuery,
        handleChange: handleChange
      });
      return function () {
        // clean up 1
        mediaQuery.removeListener(handleChange);
      };
    });
    return function () {
      // clean up 2: for safety
      listeners.forEach(function (_ref3) {
        var mediaQuery = _ref3.mediaQuery,
            handleChange = _ref3.handleChange;
        mediaQuery.removeListener(handleChange);
      });
      listeners.clear();
    };
  }, [mediaQueries, breakpoints, update, env.window]);
  return current;
}

function getClosestValue(values, breakpoint, breakpoints$1) {
  if (breakpoints$1 === void 0) {
    breakpoints$1 = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints */ .AV;
  }

  var index = Object.keys(values).indexOf(breakpoint);

  if (index !== -1) {
    return values[breakpoint];
  }

  var stopIndex = breakpoints$1.indexOf(breakpoint);

  while (stopIndex >= 0) {
    var key = breakpoints$1[stopIndex];

    if (values[key] != null) {
      index = stopIndex;
      break;
    }

    stopIndex -= 1;
  }

  if (index !== -1) {
    var _key = breakpoints$1[index];
    return values[_key];
  }

  return undefined;
}

/**
 * React hook for getting the value for the current breakpoint from the
 * provided responsive values object.
 *
 * @param values
 * @param defaultBreakpoint default breakpoint name
 * (in non-window environments like SSR)
 *
 * For SSR, you can use a package like [is-mobile](https://github.com/kaimallea/isMobile)
 * to get the default breakpoint value from the user-agent
 *
 * @example
 * const width = useBreakpointValue({ base: '150px', md: '250px' })
 */

function useBreakpointValue(values, defaultBreakpoint) {
  var breakpoint = useBreakpoint(defaultBreakpoint);
  var theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
  if (!breakpoint) return undefined;
  /**
   * Get the non-number breakpoint keys from the provided breakpoints
   */

  var breakpoints = Object.keys(theme.breakpoints);
  var obj = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(values) ? (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromEntries */ .sq)(Object.entries((0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return [key, value];
  })) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}




/***/ }),

/***/ 46299:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/criar-perfil-gratis",
      function () {
        return __webpack_require__(41594);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ Error; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63706);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Error = function(_param) /*#__PURE__*/ {
    var innerHTML = _param.innerHTML, props = _objectWithoutProperties(_param, [
        "innerHTML"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Alert */ .bZ, _objectSpread({
        status: "error",
        mt: "4",
        p: "4",
        w: "100%",
        fontSize: "14px",
        bgColor: "errors.100",
        borderColor: "errors.100",
        borderRadius: "4px",
        "data-testid": "error"
    }, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AlertIcon */ .zM, {
                color: "errors.200"
            }),
            innerHTML && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                color: "text.100",
                fontStyle: "italic",
                "data-testid": "error-text",
                dangerouslySetInnerHTML: {
                    __html: innerHTML
                }
            })
        ]
    }));
};



/***/ }),

/***/ 52527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ FieldTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 5 modules
var chakra_ui_system_esm = __webpack_require__(47386);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(11860);
;// CONCATENATED MODULE: ./src/components/atoms/form/isRequiredStar/index.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var IsRequiredStar = function(_param) /*#__PURE__*/ {
    var _color = _param.color, color = _color === void 0 ? 'red' : _color, props = _objectWithoutProperties(_param, [
        "color"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, _objectSpread({
        display: "inline",
        color: color,
        ml: 1
    }, props, {
        children: "*"
    }));
};
/* harmony default export */ var isRequiredStar = (IsRequiredStar);

;// CONCATENATED MODULE: ./src/components/atoms/form/fieldTitle/variants/standard.tsx
var standard = {
    color: 'text.100',
    fontWeight: '700',
    fontSize: '14px',
    mb: 4,
    mr: 0
};

;// CONCATENATED MODULE: ./src/components/atoms/form/fieldTitle/variants/simpleItalic.tsx
var simpleItalic = {
    color: 'text.100',
    fontWeight: '400',
    fontSize: '14px',
    fontStyle: 'italic',
    mb: 2,
    mr: 0
};

;// CONCATENATED MODULE: ./src/components/atoms/form/fieldTitle/variants/bold.tsx
var bold = {
    color: 'text.100',
    fontWeight: '700',
    fontSize: '14px',
    mb: 2,
    mr: 0
};

;// CONCATENATED MODULE: ./src/components/atoms/form/fieldTitle/variants/simpleGray.tsx
var simpleGray = {
    color: 'text.300',
    fontWeight: '600',
    fontSize: '14px',
    mb: 2,
    mr: 0
};

;// CONCATENATED MODULE: ./src/components/atoms/form/fieldTitle/variants/index.tsx




var variants = {
    standard: standard,
    simpleItalic: simpleItalic,
    bold: bold,
    simpleGray: simpleGray
};

;// CONCATENATED MODULE: ./src/components/atoms/form/fieldTitle/index.tsx




function fieldTitle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fieldTitle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fieldTitle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function fieldTitle_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = fieldTitle_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function fieldTitle_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FieldTitle = (0,chakra_ui_system_esm/* forwardRef */.Gp)(function(_param, ref) {
    var _variant = _param.variant, variant = _variant === void 0 ? 'standard' : _variant, starColor = _param.starColor, isRequired = _param.isRequired, label = _param.label, helpLabel = _param.helpLabel, helpLinkedLabel = _param.helpLinkedLabel, helpLink = _param.helpLink, props = fieldTitle_objectWithoutProperties(_param, [
        "variant",
        "starColor",
        "isRequired",
        "label",
        "helpLabel",
        "helpLinkedLabel",
        "helpLink"
    ]);
    if (!label) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
        alignItems: "middle",
        spacing: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormLabel */.lX, fieldTitle_objectSpread({
                ref: ref,
                color: "text.100",
                fontWeight: "700",
                fontSize: "sm",
                mb: 4,
                mr: 0
            }, variants[variant], props, {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(isRequiredStar, {
                        color: starColor
                    })
                ]
            })),
            helpLabel && helpLinkedLabel && helpLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                    color: "text.100",
                    fontWeight: "500",
                    fontSize: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                            color: "primary.500",
                            fontWeight: "500",
                            href: helpLink,
                            fontSize: "sm",
                            children: helpLinkedLabel
                        }),
                        ' ',
                        helpLabel
                    ]
                })
            })
        ]
    }));
});

FieldTitle.displayName = 'FieldTitle';


/***/ }),

/***/ 57917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ FormIconError; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95196);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69070);



var FormIconError = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
        as: _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .WarningIcon */ .aN,
        position: "absolute",
        top: "50px",
        color: "errors.200",
        right: {
            base: '-25px',
            md: '-30px'
        },
        sx: props,
        "data-testid": "error-icon"
    });
};


/***/ }),

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var fontSizes = {
    h4: [
        '14px',
        '14px',
        '16px',
        '16px'
    ],
    h3: [
        '16px',
        '16px',
        '20px',
        '20px'
    ],
    h2: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h1: [
        '36px',
        '36px',
        '36px',
        '36px'
    ]
};
var boostFontSizes = {
    h4: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h3: [
        '40px',
        '40px',
        '48px',
        '48px'
    ],
    h2: [
        '48px',
        '48px',
        '60px',
        '60px'
    ],
    h1: [
        '60px',
        '60px',
        '68px',
        '68px'
    ]
};
var fontWeights = {
    h4: '500',
    h3: '500',
    h2: '600',
    h1: '600'
};
var Heading = function(_param) /*#__PURE__*/ {
    var children = _param.children, _format = _param.format, format = _format === void 0 ? 'h1' : _format, _boostSizeLength = _param.boostSizeLength, boostSizeLength = _boostSizeLength === void 0 ? 0 : _boostSizeLength, _pt = _param.pt, pt = _pt === void 0 ? 2 : _pt, _mt = _param.mt, mt = _mt === void 0 ? 2 : _mt, props = _objectWithoutProperties(_param, [
        "children",
        "format",
        "boostSizeLength",
        "pt",
        "mt"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, _objectSpread({
        as: format,
        fontSize: boostSizeLength ? boostFontSizes[format] : fontSizes[format] || fontSizes.h1,
        fontWeight: fontWeights[format] || fontWeights.h1,
        letterSpacing: "1px",
        color: "text.100",
        lineHeight: "normal",
        "data-testid": "heading",
        pt: pt,
        mt: mt
    }, props, {
        children: boostSizeLength && children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                children.slice(0, boostSizeLength),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    display: "inline",
                    fontSize: fontSizes[format] || fontSizes.h1,
                    children: children.slice(boostSizeLength)
                })
            ]
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 15302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80241);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52970);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BrandLogo = function(_param) {
    var src = _param.src, alt = _param.alt, _w = _param.w, w = _w === void 0 ? [
        130
    ] : _w, _h = _param.h, h = _h === void 0 ? [
        60
    ] : _h, props = _objectWithoutProperties(_param, [
        "src",
        "alt",
        "w",
        "h"
    ]);
    var width = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointValue */ .Sx)(w);
    var height = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointValue */ .Sx)(h);
    if (width && height) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({
            src: src,
            alt: alt,
            width: width,
            height: height
        }, props)));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}));
};
/* harmony default export */ __webpack_exports__["Z"] = (BrandLogo);


/***/ }),

/***/ 1076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ListItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95196);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82836);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ListItem = function(_param) /*#__PURE__*/ {
    var children = _param.children, icon = _param.icon, _variant = _param.variant, variant = _variant === void 0 ? 'notClosable' : _variant, onClose = _param.onClose, props = _objectWithoutProperties(_param, [
        "children",
        "icon",
        "variant",
        "onClose"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC, _objectSpread({
        my: "4",
        color: "text.100",
        lineHeight: 5
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
            alignItems: [
                'flex-start',
                'flex-start',
                'center',
                'center'
            ],
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        children: [
                            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                as: icon,
                                w: 5,
                                h: 5,
                                color: "primary.500",
                                mr: [
                                    2,
                                    2,
                                    4,
                                    4
                                ],
                                "data-testid": "left-icon"
                            }),
                            children
                        ]
                    })
                }),
                variant === 'closable' && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                    as: react_icons_md__WEBPACK_IMPORTED_MODULE_3__/* .MdClose */ .FU5,
                    w: 5,
                    h: 5,
                    color: "black.400",
                    onClick: onClose,
                    cursor: "pointer",
                    "data-testid": "close-icon",
                    _hover: {
                        color: 'secondary.100',
                        transition: '0.2s'
                    }
                })
            ]
        })
    }));
};



/***/ }),

/***/ 63198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ NextSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22319);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var noIndexAndFollowPage = "production" !== 'production';
var NextSeo = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, _objectSpread({}, props, {
        noindex: noIndexAndFollowPage,
        nofollow: noIndexAndFollowPage
    }));
};


/***/ }),

/***/ 1689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11860);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29237);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95196);
/* harmony import */ var components_atoms_formIconError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57917);
/* harmony import */ var components_atoms_form_error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62472);
/* harmony import */ var components_atoms_form_fieldTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52527);
/* harmony import */ var lib_utils_getErrorMessage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6103);
/* harmony import */ var _variants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96830);

/* eslint-disable dot-notation */ 






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Field = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var borderColor = _param.borderColor, _variant = _param.variant, variant = _variant === void 0 ? 'outline' : _variant, onRightIconClick = _param.onRightIconClick, onLeftIconClick = _param.onLeftIconClick, _height = _param.height, height = _height === void 0 ? '40px' : _height, _width = _param.width, width = _width === void 0 ? '100%' : _width, _type = _param.type, type = _type === void 0 ? 'text' : _type, labelVariant = _param.labelVariant, placeholder = _param.placeholder, isRequired = _param.isRequired, starColor = _param.starColor, rightIcon = _param.rightIcon, _iconColor = _param.iconColor, iconColor = _iconColor === void 0 ? 'text.100' : _iconColor, leftIcon = _param.leftIcon, register = _param.register, errors = _param.errors, error = _param.error, label = _param.label, name = _param.name, _showErrorIcon = _param.showErrorIcon, showErrorIcon = _showErrorIcon === void 0 ? false : _showErrorIcon, helpText = _param.helpText, helpTextMiddle = _param.helpTextMiddle, props = _objectWithoutProperties(_param, [
        "borderColor",
        "variant",
        "onRightIconClick",
        "onLeftIconClick",
        "height",
        "width",
        "type",
        "labelVariant",
        "placeholder",
        "isRequired",
        "starColor",
        "rightIcon",
        "iconColor",
        "leftIcon",
        "register",
        "errors",
        "error",
        "label",
        "name",
        "showErrorIcon",
        "helpText",
        "helpTextMiddle"
    ]);
    var ref1, ref2, ref3;
    var errorMessage = errors ? (0,lib_utils_getErrorMessage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(name, errors) : error === null || error === void 0 ? void 0 : error.message;
    var registerProps = register && name ? register(name) : {};
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .FormControl */ .NI, _objectSpread({}, props, registerProps, {
        position: "relative",
        width: width,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_form_fieldTitle__WEBPACK_IMPORTED_MODULE_4__/* .FieldTitle */ .m, {
                isRequired: isRequired,
                label: label,
                variant: labelVariant,
                starColor: starColor
            }),
            helpTextMiddle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .FormHelperText */ .Q6, {
                fontStyle: "italic",
                color: "text.200",
                fontSize: "0.9rem",
                mt: 0,
                pb: 4,
                children: helpTextMiddle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .InputGroup */ .BZ, {
                flexDirection: "column",
                children: [
                    leftIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .InputLeftElement */ .Z8, {
                        cursor: onLeftIconClick ? 'pointer' : 'default',
                        onClick: onLeftIconClick,
                        height: height,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .JO, {
                            as: leftIcon,
                            color: "text.100",
                            w: 5,
                            h: 5,
                            mx: 4
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Input */ .II, _objectSpread({
                        "data-testid": "input",
                        "aria-label": label,
                        placeholder: placeholder,
                        height: height,
                        width: width,
                        type: type,
                        name: name,
                        ref: ref,
                        paddingRight: "12px",
                        borderRadius: 4,
                        fontWeight: "400",
                        fontSize: "14px",
                        py: 2
                    }, _variants__WEBPACK_IMPORTED_MODULE_6__/* .variants */ .o[variant], {
                        borderColor: errorMessage ? 'errors.200' : borderColor !== null && borderColor !== void 0 ? borderColor : _variants__WEBPACK_IMPORTED_MODULE_6__/* .variants */ .o[variant].borderColor,
                        _focus: {
                            borderColor: errorMessage ? 'errors.200' : (ref1 = _variants__WEBPACK_IMPORTED_MODULE_6__/* .variants */ .o[variant]['_focus']) === null || ref1 === void 0 ? void 0 : ref1.borderColor,
                            bgColor: (ref2 = _variants__WEBPACK_IMPORTED_MODULE_6__/* .variants */ .o[variant]['_focus']) === null || ref2 === void 0 ? void 0 : ref2.bgColor,
                            boxShadow: 'none'
                        },
                        _hover: {
                            borderColor: errorMessage ? 'errors.200' : (ref3 = _variants__WEBPACK_IMPORTED_MODULE_6__/* .variants */ .o[variant]['_hover']) === null || ref3 === void 0 ? void 0 : ref3.borderColor
                        }
                    })),
                    rightIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .InputRightElement */ .xH, {
                        cursor: onRightIconClick ? 'pointer' : 'default',
                        onClick: onRightIconClick,
                        height: height,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .JO, {
                            as: rightIcon,
                            color: iconColor,
                            w: 5,
                            h: 5,
                            mx: 4
                        })
                    }),
                    errorMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_form_error__WEBPACK_IMPORTED_MODULE_3__/* .Error */ .j, {
                        width: width,
                        innerHTML: errorMessage
                    })
                ]
            }),
            helpText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .FormHelperText */ .Q6, {
                fontStyle: "italic",
                color: "text.200",
                fontSize: "0.9rem",
                children: helpText
            }),
            errorMessage && showErrorIcon && !helpTextMiddle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_formIconError__WEBPACK_IMPORTED_MODULE_2__/* .FormIconError */ .c, {}),
            errorMessage && showErrorIcon && helpTextMiddle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_atoms_formIconError__WEBPACK_IMPORTED_MODULE_2__/* .FormIconError */ .c, {
                top: "107px"
            })
        ]
    })));
});
Field.displayName = 'Field';
/* harmony default export */ __webpack_exports__["Z"] = (Field);


/***/ }),

/***/ 96830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ variants; }
});

;// CONCATENATED MODULE: ./src/components/molecules/form/field/variants/outline.tsx
var outline = {
    borderColor: 'text.200',
    bgColor: 'background.700',
    color: 'text.100',
    _focus: {
        borderColor: 'primary.500',
        bgColor: 'background.700'
    }
};

;// CONCATENATED MODULE: ./src/components/molecules/form/field/variants/solid.tsx
var solid = {
    borderColor: 'background.900',
    bgColor: 'background.900',
    color: 'text.100',
    _hover: {
        borderColor: 'secondary.50'
    },
    _focus: {
        bgColor: 'secondary.50',
        borderColor: 'secondary.50'
    }
};

;// CONCATENATED MODULE: ./src/components/molecules/form/field/variants/solidWhite.tsx
var solidWhite = {
    borderColor: 'background.900',
    bgColor: 'white',
    color: 'text.900',
    _hover: {
        borderColor: 'secondary.50'
    },
    _focus: {
        bgColor: 'secondary.50',
        borderColor: 'secondary.50'
    }
};

;// CONCATENATED MODULE: ./src/components/molecules/form/field/variants/ridge.tsx
var ridge = {
    borderColor: 'background.700',
    bgColor: 'background.700',
    color: 'text.100',
    _hover: {
        borderColor: 'background.700'
    },
    _focus: {
        bgColor: 'background.700',
        borderColor: 'background.700'
    }
};

;// CONCATENATED MODULE: ./src/components/molecules/form/field/variants/index.tsx




var variants = {
    outline: outline,
    solid: solid,
    ridge: ridge,
    solidWhite: solidWhite
};


/***/ }),

/***/ 19713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15579);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75332);
/* harmony import */ var lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70333);
/* harmony import */ var lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29770);
/* harmony import */ var lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12062);






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * Hook that exposes functions to handle user sessions.
 */ var useSession = function() {
    var ref = _slicedToArray((0,react_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), 3), cookies = ref[0], setCookie = ref[1], removeCookie = ref[2];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''), currentToken = ref1[0], setCurrentToken = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var authTokenCookie = cookies[lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_TOKEN */ .UA];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setCurrentToken(authTokenCookie);
    }, [
        authTokenCookie
    ]);
    var createSession = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(token, userType) {
        var redirectTo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .ROOT */ .Dx;
        setCookie(lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_TOKEN */ .UA, token, {
            path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .ROOT */ .Dx
        });
        setCookie(lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__/* .USER_TYPE */ .$A, userType, {
            path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .ROOT */ .Dx
        });
        router.push(redirectTo);
    }, [
        setCookie,
        router
    ]);
    var endSession = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        removeCookie(lib_constants_auth__WEBPACK_IMPORTED_MODULE_3__/* .AUTH_TOKEN */ .UA, {
            path: '/'
        });
        removeCookie(lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__/* .USER_TYPE */ .$A, {
            path: '/'
        });
        removeCookie(lib_constants_cookies__WEBPACK_IMPORTED_MODULE_5__/* .NEXT_LOCALE */ .Ky, {
            path: '/'
        });
        window.location.href = lib_constants_paths__WEBPACK_IMPORTED_MODULE_4__/* .LOGOUT */ .Nv;
    }, [
        removeCookie
    ]);
    var payload = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            createSession: createSession,
            endSession: endSession,
            currentToken: currentToken
        };
    }, [
        currentToken,
        createSession,
        endSession
    ]);
    return payload;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSession);


/***/ }),

/***/ 20477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ candidateColorScheme; }
/* harmony export */ });
var candidateColorScheme = {
    errors: {
        100: '#FB5A82',
        200: '#B81A4C'
    },
    primary: {
        100: '#F0F0FF',
        200: '#9412DC',
        150: '#f1ddfc',
        300: '#C570F3',
        400: '#F7E7FF',
        500: '#9412DC',
        700: '#6E2B77'
    },
    secondary: {
        100: '#E0FBF6',
        200: '#41A9B9'
    },
    background: {
        50: '#FAFAFA',
        100: '#F0F1F2',
        200: '#CBD5E0',
        400: '#939DA5',
        700: '#202024',
        800: '#18171B',
        900: '#040c10'
    },
    text: {
        100: '#FFFFFF',
        200: '#acacad',
        300: '#11273a',
        400: '#1F7161',
        600: '#667078',
        700: '#586169',
        900: '#11273A'
    }
};


/***/ }),

/***/ 13735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ yup; }
});

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(52595);
;// CONCATENATED MODULE: ./src/lib/settings/yup/locale/index.ts
/* eslint-disable no-template-curly-in-string */ /**
 * Defines localization for Yup according to i18n translations.
 */ var locale = {
    mixed: {
        default: 'Campo inv\xe1lido',
        required: 'Este campo \xe9 obrigat\xf3rio',
        notType: 'Este campo \xe9 obrigat\xf3rio',
        oneOf: 'Este campo \xe9 obrigat\xf3rio',
        max: 'Este campo precisa ser menor ou igual a ${max}.',
        min: 'Este campo precisa ser maior ou igual a ${min}.'
    },
    string: {
        email: 'Este campo deve ser um e-mail v\xe1lido',
        max: 'Este campo precisa ser menor ou igual a ${max}.',
        min: 'Este campo precisa ser maior ou igual a ${min}.'
    },
    number: {
        max: 'Este campo precisa ser menor ou igual a ${max}.',
        min: 'Este campo precisa ser maior ou igual a ${min}.'
    }
};
/* harmony default export */ var yup_locale = (locale);

;// CONCATENATED MODULE: ./src/lib/settings/yup/index.ts


es.setLocale(yup_locale);
/* harmony default export */ var yup = (es);


/***/ }),

/***/ 22510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ fullNameTest; }
});

;// CONCATENATED MODULE: ./src/lib/utils/validation/validateFullName/index.ts
/**
 * Check if as a valid full name
 *
 * @param {string} name
 * @returns {boolean}
 */ var validateFullName = function(name) {
    if (!name) return false;
    var arrName = name.trim().split(' ');
    return arrName.length >= 2;
};

;// CONCATENATED MODULE: ./src/lib/settings/yup/tests/fullNameTest.ts

/**
 * Check if as a valid full name
 */ var fullNameTest = function() {
    return {
        name: 'fullName',
        exclusive: false,
        message: 'Digite um nome e sobrenome.',
        test: validateFullName
    };
};


/***/ }),

/***/ 6103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89914);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Returns error message for a given field name.
 *
 * When yup schemas defines nested objects, `errors` may contain
 * objects such as:
 *
 * {
 *   foo: {
 *     bar: {
 *       message: "This field is required",
 *     }
 *   }
 * }
 *
 * And `name` would be something like `foo.bar`.
 *
 * @param errors The errors.
 * @param name The field name.
 */ var getErrorMessage = function(name, errors) {
    if (name && errors) {
        var error = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(errors, name);
        if (error) {
            return (error === null || error === void 0 ? void 0 : error.message) || 'Este campo \xe9 obrigat\xf3rio.';
        }
    }
    return undefined;
};
/* harmony default export */ __webpack_exports__["Z"] = (getErrorMessage);


/***/ }),

/***/ 41594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(53857);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(64816);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./src/lib/constants/translateNamespaces.ts
var translateNamespaces = __webpack_require__(8366);
// EXTERNAL MODULE: ./src/lib/settings/theme/colors/candidate.ts
var candidate = __webpack_require__(20477);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
// EXTERNAL MODULE: ./src/components/organisms/footer/index.tsx + 3 modules
var footer = __webpack_require__(81241);
// EXTERNAL MODULE: ./src/lib/constants/header.ts
var header = __webpack_require__(71458);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(80241);
;// CONCATENATED MODULE: ./public/woman-relax.png
/* harmony default export */ var woman_relax = ({"src":"/_next/static/media/woman-relax.56b26ac9.png","height":5450,"width":4918,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAZlBMVEWHbW3puJ3DkHOxV058UD3VXGHQmoB6OyonCgC0c1uIY0+ofmd7VD2ecVz/1KqQYUrepInTmoKvgWKOWkltQi6fRDttQjCUX0+ESTbCd2jfp4zUfGvpgHjIbWDbbmvvuJvHjXPfgnTSzauDAAAAG3RSTlMB3p393fu1/Q39Z/pbvwa9hMOpO/P89DD+5nJjLuCRAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPklEQVR4nBXBBRKAIAAAwaPBwi5C//9Kx12gaxt+8emBwetXexiXNezHjQhndpdgKi47ZbFpq6pI5mSqSfIDTNoC0vq1x4gAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/components/atoms/images/relaxWoman/index.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var RelaxWoman = function(_param) /*#__PURE__*/ {
    var layout = _param.layout, props = _objectWithoutProperties(_param, [
        "layout"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, _objectSpread({}, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
            src: woman_relax,
            alt: "Mulher meditando",
            layout: layout
        })
    }));
};
/* harmony default export */ var relaxWoman = (RelaxWoman);

// EXTERNAL MODULE: ./src/components/atoms/heading/index.tsx
var heading = __webpack_require__(68590);
// EXTERNAL MODULE: ./src/components/atoms/button/index.tsx + 7 modules
var atoms_button = __webpack_require__(65186);
;// CONCATENATED MODULE: ./src/components/atoms/badgeText/index.tsx


var BadgeText = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
        bgColor: "background.900",
        color: "text.100",
        fontSize: "16px",
        fontFamily: "heading",
        px: 4,
        py: 2,
        borderRadius: 32,
        mb: "8",
        display: "inline-block",
        children: children
    });
};
/* harmony default export */ var badgeText = (BadgeText);

;// CONCATENATED MODULE: ./src/components/molecules/candidates/freePlatformCto/index.tsx





var FreePlatformCto = function(param) {
    var freePlatformBadge = param.freePlatformBadge, freePlatformTitle = param.freePlatformTitle, freePlatformButton = param.freePlatformButton, freePlatformButtonIcon = param.freePlatformButtonIcon, formRef = param.formRef;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        minH: "100%",
        px: 8,
        w: [
            '100%',
            '100%',
            '500px',
            '500px'
        ],
        ml: [
            0,
            0,
            4,
            4
        ],
        mb: [
            16,
            16,
            0,
            0
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(badgeText, {
                children: freePlatformBadge
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                format: "h2",
                w: "100%",
                mb: "8",
                children: freePlatformTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                rightIcon: freePlatformButtonIcon,
                p: "8px 0px",
                onClick: function() {
                    var ref;
                    return formRef === null || formRef === void 0 ? void 0 : (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
                },
                _hover: {
                    bgColor: 'primary.500'
                },
                children: freePlatformButton
            })
        ]
    });
};
/* harmony default export */ var freePlatformCto = (FreePlatformCto);

;// CONCATENATED MODULE: ./src/components/organisms/candidates/freePlatform/index.tsx




var FreePlatform = function(param) {
    var freePlatformBadge = param.freePlatformBadge, freePlatformTitle = param.freePlatformTitle, freePlatformButton = param.freePlatformButton, freePlatformButtonIcon = param.freePlatformButtonIcon, formRef = param.formRef;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bg: "primary.500",
        w: "100%",
        pt: "20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            justifyContent: "center",
            alignItems: "center",
            flexDir: [
                'column-reverse',
                'column-reverse',
                'row',
                'row'
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(relaxWoman, {
                    w: [
                        '255px',
                        '255px',
                        '525px',
                        '525px'
                    ],
                    h: [
                        '300px',
                        '300px',
                        '600px',
                        '600px'
                    ],
                    layout: "fill",
                    minH: "100%",
                    px: 8,
                    position: "relative"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(freePlatformCto, {
                    freePlatformBadge: freePlatformBadge,
                    freePlatformTitle: freePlatformTitle,
                    freePlatformButton: freePlatformButton,
                    freePlatformButtonIcon: freePlatformButtonIcon,
                    formRef: formRef
                })
            ]
        })
    });
};
/* harmony default export */ var freePlatform = (FreePlatform);

;// CONCATENATED MODULE: ./src/components/atoms/card/index.tsx


function card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function card_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = card_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function card_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Card = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = card_objectWithoutProperties(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, card_objectSpread({
        p: 8,
        pb: [
            8,
            16
        ],
        borderRadius: 32,
        minH: "100%"
    }, props, {
        children: children
    }));
};
/* harmony default export */ var card = (Card);

;// CONCATENATED MODULE: ./src/components/atoms/card/title/index.tsx


var CardTitle = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
        fontSize: [
            '14px',
            '16px'
        ],
        color: "primary.500",
        fontWeight: "600",
        mb: "0.5",
        children: children
    });
};
/* harmony default export */ var card_title = (CardTitle);

;// CONCATENATED MODULE: ./src/components/atoms/card/subTitle/index.tsx


function subTitle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function subTitle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            subTitle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function subTitle_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = subTitle_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function subTitle_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CardSubTitle = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = subTitle_objectWithoutProperties(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, subTitle_objectSpread({
        fontSize: [
            '12px',
            '14px'
        ],
        fontWeight: "600",
        textAlign: "left"
    }, props, {
        children: children
    }));
};
/* harmony default export */ var subTitle = (CardSubTitle);

;// CONCATENATED MODULE: ./src/components/atoms/card/body/index.tsx


var CardBody = function(param) {
    var children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "26px",
        color: "text.100",
        "data-testid": "card-body",
        textAlign: "left",
        children: children
    });
};
/* harmony default export */ var body = (CardBody);

;// CONCATENATED MODULE: ./src/components/molecules/card/index.tsx







function molecules_card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function molecules_card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            molecules_card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function molecules_card_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = molecules_card_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function molecules_card_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var card_Card = function(_param) /*#__PURE__*/ {
    var leftImageSrc = _param.leftImageSrc, leftImageAlt = _param.leftImageAlt, rightImageSrc = _param.rightImageSrc, rightImageAlt = _param.rightImageAlt, rightImageWidth = _param.rightImageWidth, rightImageHeight = _param.rightImageHeight, subtitle = _param.subtitle, children = _param.children, title = _param.title, props = molecules_card_objectWithoutProperties(_param, [
        "leftImageSrc",
        "leftImageAlt",
        "rightImageSrc",
        "rightImageAlt",
        "rightImageWidth",
        "rightImageHeight",
        "subtitle",
        "children",
        "title"
    ]);
    return (0,jsx_runtime.jsxs)(card, molecules_card_objectSpread({
        bgColor: "background.800"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                spacing: [
                    2,
                    4
                ],
                mb: 8,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* HStack */.Ug, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                float: "left",
                                mr: [
                                    2,
                                    4
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: leftImageSrc,
                                    alt: leftImageAlt,
                                    width: "50px",
                                    height: "50px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Stack */.Kq, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card_title, {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(subTitle, {
                                        color: "text.100",
                                        children: subtitle
                                    })
                                ]
                            })
                        ]
                    }),
                    rightImageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        w: "35%",
                        float: "left",
                        mr: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: rightImageSrc,
                            width: rightImageWidth,
                            height: rightImageHeight,
                            alt: rightImageAlt,
                            layout: "intrinsic"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(body, {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var molecules_card = (card_Card);

// EXTERNAL MODULE: ./src/components/atoms/images/brandLogo/index.tsx
var brandLogo = __webpack_require__(15302);
;// CONCATENATED MODULE: ./src/components/organisms/candidates/geekComments/index.tsx






var GeekComments = function(param) {
    var companiesTitle = param.companiesTitle, companiesLogo = param.companiesLogo, geekiesTitle = param.geekiesTitle, geekiesComments = param.geekiesComments, geekCommentsButton = param.geekCommentsButton, geekCommentsButtonIcon = param.geekCommentsButtonIcon, formRef = param.formRef;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        bg: "background.900",
        w: "100%",
        py: "20",
        px: [
            4,
            4,
            0,
            0
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "16px",
                color: "text.200",
                textAlign: "center",
                mb: [
                    8,
                    8,
                    0,
                    0
                ],
                children: companiesTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                maxW: "container.xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        wrap: "wrap",
                        justify: "center",
                        alignItems: "center",
                        mb: [
                            32,
                            32,
                            8,
                            8
                        ],
                        children: companiesLogo.map(function(companyLogo) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                p: [
                                    2,
                                    2,
                                    8,
                                    8
                                ],
                                "data-testid": "company-logo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(brandLogo/* default */.Z, {
                                    src: companyLogo.src,
                                    alt: companyLogo.alt,
                                    w: companyLogo.w,
                                    h: companyLogo.h
                                })
                            }, companyLogo.alt);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                        format: "h2",
                        textAlign: "center",
                        mb: [
                            8,
                            8,
                            16,
                            16
                        ],
                        children: geekiesTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Grid */.rj, {
                        templateColumns: [
                            null,
                            'repeat(1, 1fr)',
                            null,
                            'repeat(3, 1fr)'
                        ],
                        gap: 8,
                        mb: 8,
                        children: geekiesComments.map(function(geekComment) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                "data-testid": "geek-comment",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_card, {
                                    leftImageSrc: geekComment.image.src,
                                    leftImageAlt: geekComment.image.alt,
                                    title: geekComment.name,
                                    subtitle: geekComment.position,
                                    children: geekComment.comment
                                })
                            }, geekComment.name);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            w: "240px",
                            size: "xl",
                            rightIcon: geekCommentsButtonIcon,
                            onClick: function() {
                                var ref;
                                return formRef === null || formRef === void 0 ? void 0 : (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
                            },
                            children: geekCommentsButton
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var geekComments = (GeekComments);

// EXTERNAL MODULE: ./src/components/organisms/landingPageHeader/index.tsx + 1 modules
var landingPageHeader = __webpack_require__(28147);
// EXTERNAL MODULE: ./src/components/atoms/listItem/index.tsx
var atoms_listItem = __webpack_require__(1076);
;// CONCATENATED MODULE: ./public/man-with-glass.png
/* harmony default export */ var man_with_glass = ({"src":"/_next/static/media/man-with-glass.41f2c5cf.png","height":1776,"width":1791,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEVMaXGGlXWwvp7///+Zo3txcUtjYj6IjmaLlXUfFw9lY0FALSeviHnNxK6TqJFZRj2thnRGPh5tYFebZVahaFVnaUmTaFlVTkcvKxF4d09pclZJSC5nblCbqYVec193dEmFh1rHloFjVihgs8FVAAAAHXRSTlMA/JkJ+Kr+/LgRwqGXaHnk19H+xvnU5+I73lD8lJxde0wAAAAJcEhZcwAAITgAACE4AUWWMWAAAABCSURBVHicHcZFEoAwAMDAFKq4ewX+/0gGctkAZev4cstd5f+NU1d/buswywaOGMKjfcaVTIp9YVHaCKmA/TTCW3gBZCIC/aloXKMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/components/atoms/images/manWithGlass/index.tsx




function manWithGlass_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function manWithGlass_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            manWithGlass_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function manWithGlass_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = manWithGlass_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function manWithGlass_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// this is the Largest Contentful Paint element in /criar-perfil-gratis. So property priority is set to true
var ManWithGlass = function(_param) /*#__PURE__*/ {
    var layout = _param.layout, props = manWithGlass_objectWithoutProperties(_param, [
        "layout"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, manWithGlass_objectSpread({}, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
            src: man_with_glass,
            layout: layout,
            priority: true,
            alt: "Homem feliz e sorridente segurando o oculos"
        })
    }));
};
/* harmony default export */ var manWithGlass = (ManWithGlass);

;// CONCATENATED MODULE: ./public/purple-circle.svg
/* harmony default export */ var purple_circle = ({"src":"/_next/static/media/purple-circle.acded791.svg","height":306,"width":322});
;// CONCATENATED MODULE: ./src/components/atoms/images/purpleCircle/index.tsx




function purpleCircle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function purpleCircle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            purpleCircle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function purpleCircle_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = purpleCircle_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function purpleCircle_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var PurpleCircle = function(_param) /*#__PURE__*/ {
    var layout = _param.layout, props = purpleCircle_objectWithoutProperties(_param, [
        "layout"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, purpleCircle_objectSpread({}, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
            src: purple_circle,
            alt: "Circulo roxo",
            layout: layout,
            priority: true
        })
    }));
};
/* harmony default export */ var purpleCircle = (PurpleCircle);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/chakra-ui-checkbox.esm.js
var chakra_ui_checkbox_esm = __webpack_require__(23434);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var dist_index_esm = __webpack_require__(46830);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(25995);
// EXTERNAL MODULE: ./src/components/molecules/form/field/index.tsx
var field = __webpack_require__(1689);
// EXTERNAL MODULE: ./src/lib/settings/yup/index.ts + 1 modules
var yup = __webpack_require__(13735);
;// CONCATENATED MODULE: ./src/lib/schemas/candidates/firstStepRegistration.ts

var firstStepRegistrationSchema = yup/* default.object */.Z.object({
    email: yup/* default.string */.Z.string().email('Digite um e-mail v\xe1lido.').required('Digite um e-mail v\xe1lido.'),
    acceptEmailNotifications: yup/* default.boolean */.Z.boolean().required()
});

// EXTERNAL MODULE: ./src/lib/constants/paths.ts
var paths = __webpack_require__(29770);
;// CONCATENATED MODULE: ./src/components/organisms/candidates/registrationForm/firstStep/index.tsx










function firstStep_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function firstStep_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            firstStep_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FormFirstStep = function(param1) {
    var submitFirstStep = param1.submitFirstStep, formErrors = param1.formErrors;
    var ref1 = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(firstStepRegistrationSchema)
    }), register = ref1.register, handleSubmit = ref1.handleSubmit, setError = ref1.setError, errors = ref1.formState.errors, control = ref1.control;
    (0,react.useEffect)(function() {
        formErrors === null || formErrors === void 0 ? void 0 : formErrors.forEach(function(formError) {
            return setError('email', formError);
        });
    }, [
        formErrors,
        setError
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
            as: "form",
            onSubmit: handleSubmit(submitFirstStep),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    flexWrap: "wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, firstStep_objectSpread({
                            height: "50px",
                            width: [
                                '100%',
                                '100%',
                                '300px',
                                '300px'
                            ],
                            mr: [
                                0,
                                0,
                                4,
                                4
                            ],
                            mb: [
                                4,
                                4,
                                0,
                                0
                            ],
                            leftIcon: index_esm/* AiOutlineMail */.Dme,
                            "aria-label": "E-mail",
                            label: "E-mail",
                            placeholder: "Digite o seu e-mail"
                        }, register('email', {
                            required: true
                        }), {
                            errors: errors,
                            isRequired: true
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            size: "xl",
                            mt: "37px",
                            w: [
                                '100%',
                                '100%',
                                '240px',
                                '240px'
                            ],
                            rightIcon: index_esm/* AiOutlineArrowRight */.mGl,
                            type: "submit",
                            "aria-label": "Criar meu perfil agora",
                            children: "Criar meu perfil agora"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    fontSize: "0.9rem",
                    color: "text.200",
                    flexDirection: {
                        base: 'column',
                        sm: 'row'
                    },
                    pt: "4",
                    pb: "2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            mr: 1,
                            children: "Ao se cadastrar, voc\xea aceita nossos"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: paths/* TERMS */.WF,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                cursor: "pointer",
                                textDecor: "underline",
                                children: "termos de uso"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            mr: 1,
                            ml: 1,
                            children: "e nossa"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: paths/* POLITICS */.Zp,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                cursor: "pointer",
                                textDecor: "underline",
                                children: "pol\xedtica de privacidade"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Controller */.Qr, {
                    control: control,
                    name: "acceptEmailNotifications",
                    defaultValue: false,
                    render: function(param) {
                        var _field = param.field, onChange = _field.onChange, value = _field.value, ref = _field.ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_checkbox_esm/* Checkbox */.XZ, {
                            "aria-label": "Aceito receber e-mails com dicas da Geek",
                            borderColor: "text.100",
                            color: "text.100",
                            colorScheme: "secondary",
                            fontSize: "14px",
                            isChecked: value,
                            onChange: onChange,
                            ref: ref,
                            css: "\n                > span:first-of-type {\n                  box-shadow: unset;\n                }\n              ",
                            children: "Aceito receber e-mails com dicas da Geek"
                        });
                    }
                })
            ]
        })
    }));
};
/* harmony default export */ var firstStep = (FormFirstStep);

// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(50167);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(95196);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(75657);
// EXTERNAL MODULE: ./src/lib/settings/yup/tests/fullNameTest.ts + 1 modules
var fullNameTest = __webpack_require__(22510);
;// CONCATENATED MODULE: ./src/lib/schemas/candidates/secondStepRegistration.ts


var SecondStepRegistrationSchema = yup/* default.object */.Z.object({
    fullName: yup/* default.string */.Z.string().test((0,fullNameTest/* fullNameTest */.P)()).required('Digite um nome'),
    password: yup/* default.string */.Z.string().min(8, 'Senha muito curta').required('Digite uma senha'),
    repeatPassword: yup/* default.string */.Z.string().oneOf([
        yup/* default.ref */.Z.ref('password')
    ], 'Senhas n\xe3o s\xe3o iguais').required('Repita a senha')
});

;// CONCATENATED MODULE: ./src/components/molecules/form/passwordField/index.tsx




function passwordField_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function passwordField_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            passwordField_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PasswordField = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var ref1 = (0,react.useState)('password'), inputType = ref1[0], setInputType = ref1[1];
    var handleClick = (0,react.useCallback)(function() {
        setInputType(function(prev) {
            return prev === 'password' ? 'text' : 'password';
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, passwordField_objectSpread({
        rightIcon: inputType === 'password' ? fi_index_esm/* FiEye */.rDJ : fi_index_esm/* FiEyeOff */.rzC,
        onRightIconClick: handleClick,
        leftIcon: fi_index_esm/* FiLock */.UIZ,
        type: inputType,
        ref: ref
    }, props)));
});
PasswordField.displayName = 'PasswordField';
/* harmony default export */ var passwordField = (PasswordField);

;// CONCATENATED MODULE: ./src/components/organisms/candidates/registrationForm/secondStep/index.tsx











function secondStep_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function secondStep_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            secondStep_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FormSecondStep = function(param) {
    var submitSecondStep = param.submitSecondStep, changeFormStep = param.changeFormStep;
    var ref = (0,dist_index_esm/* useForm */.cI)({
        resolver: (0,yup_module/* yupResolver */.X)(SecondStepRegistrationSchema)
    }), register = ref.register, handleSubmit = ref.handleSubmit, errors = ref.formState.errors;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit(submitSecondStep),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                alignItems: "flex-end",
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(field/* default */.Z, secondStep_objectSpread({
                        height: "50px",
                        label: "Nome completo (m\xedn. 5 caracteres)",
                        placeholder: "Digite o seu nome completo",
                        leftIcon: fi_index_esm/* FiUser */.fzv
                    }, register('fullName', {
                        required: true
                    }), {
                        errors: errors,
                        isRequired: true
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(passwordField, secondStep_objectSpread({
                        height: "50px",
                        mt: 4,
                        label: "Senha (m\xedn. 8 caracteres)",
                        placeholder: "Digite a sua senha"
                    }, register('password'), {
                        errors: errors
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(passwordField, secondStep_objectSpread({
                        height: "50px",
                        mt: 4,
                        label: "Confirmar senha",
                        placeholder: "Digite novamente a senha"
                    }, register('repeatPassword'), {
                        errors: errors
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                        mt: 4,
                        w: "100%",
                        type: "submit",
                        rightIcon: index_esm/* AiOutlineArrowRight */.mGl,
                        children: "Criar meu perfil agora"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                justify: "space-between",
                py: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "text.100",
                        cursor: "pointer",
                        onClick: function() {
                            return changeFormStep(1);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                                as: index_esm/* AiOutlineArrowLeft */.kyg
                            }),
                            " Voltar"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "text.100",
                        children: [
                            "J\xe1 possui conta?",
                            ' ',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                                as: next_link["default"],
                                color: "primary.500",
                                href: "/",
                                children: "Fa\xe7a Login"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var secondStep = (FormSecondStep);

;// CONCATENATED MODULE: ./src/components/organisms/candidates/registrationForm/index.tsx








var RegistrationForm = function(param) {
    var formTitle = param.formTitle, formList = param.formList, formStep = param.formStep, changeFormStep = param.changeFormStep, submitFirstStep = param.submitFirstStep, submitSecondStep = param.submitSecondStep, formErrors = param.formErrors, formRef = param.formRef;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "background.900",
        w: "100%",
        position: "relative",
        overflow: "hidden",
        px: [
            4,
            4,
            0,
            0
        ],
        id: "form",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.xl",
            ref: formRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                justify: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        w: "670px",
                        paddingTop: [
                            28,
                            28,
                            60,
                            60
                        ],
                        paddingBottom: "40",
                        zIndex: "3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                                format: "h1",
                                children: formTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* UnorderedList */.QI, {
                                listStyleType: "none",
                                marginInlineStart: "0",
                                my: "8",
                                children: formList.map(function(listItem) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms_listItem/* ListItem */.H, {
                                        icon: listItem.icon,
                                        color: "text.200",
                                        children: listItem.text
                                    }, listItem.text);
                                })
                            }),
                            formStep === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(firstStep, {
                                formErrors: formErrors,
                                submitFirstStep: submitFirstStep
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(secondStep, {
                                submitSecondStep: submitSecondStep,
                                changeFormStep: changeFormStep
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(manWithGlass, {
                        w: {
                            xl: 650,
                            md: 400,
                            sm: 0
                        },
                        h: {
                            xl: 650,
                            md: 400,
                            sm: 0
                        },
                        layout: "fill",
                        pos: "absolute",
                        right: 0,
                        bottom: 0,
                        zIndex: 2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(purpleCircle, {
                        w: {
                            xl: 250,
                            md: 150,
                            sm: 0
                        },
                        h: {
                            xl: 250,
                            md: 150,
                            sm: 0
                        },
                        layout: "fill",
                        pos: "absolute",
                        right: 0,
                        bottom: "-8px",
                        zIndex: 1
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var registrationForm = (RegistrationForm);

;// CONCATENATED MODULE: ./src/components/molecules/candidates/registrationStep/index.tsx



var RegistrationStep = function(param) {
    var step = param.step, title = param.title, subTitle = param.subTitle, text = param.text;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* GridItem */.P4, {
        "data-testid": "registration-step",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "20px",
                fontFamily: "heading",
                color: "primary.500",
                mb: "4",
                children: step
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                format: "h3",
                mb: "4",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "14px",
                color: "primary.500",
                mb: "4",
                children: subTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "16px",
                color: "text.200",
                w: [
                    '100%',
                    '100%',
                    '80%',
                    '80%'
                ],
                children: text
            })
        ]
    });
};
/* harmony default export */ var registrationStep = (RegistrationStep);

;// CONCATENATED MODULE: ./src/components/organisms/candidates/registrationSteps/index.tsx




function registrationSteps_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function registrationSteps_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            registrationSteps_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RegistrationSteps = function(param) {
    var registrationStepsTitle = param.registrationStepsTitle, registrationSteps = param.registrationSteps;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bg: "background.700",
        w: "100%",
        py: "20",
        px: [
            4,
            4,
            0,
            0
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.xxl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                flexDir: [
                    'column',
                    'column',
                    'row',
                    'row'
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                        format: "h2",
                        mb: [
                            16,
                            16,
                            0,
                            0
                        ],
                        mr: 8,
                        children: registrationStepsTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Grid */.rj, {
                        templateColumns: [
                            'repeat(1, 1fr)',
                            'repeat(1, 1fr)',
                            'repeat(3, 1fr)',
                            'repeat(3, 1fr)', 
                        ],
                        gap: [
                            16,
                            16,
                            4,
                            4
                        ],
                        children: registrationSteps.map(function(step) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(registrationStep, registrationSteps_objectSpread({}, step), step.step);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var candidates_registrationSteps = (RegistrationSteps);

;// CONCATENATED MODULE: ./src/components/templates/createFreeProfile/index.tsx









var CreateFreeProfile = function(param) {
    var formTitle = param.formTitle, formList = param.formList, formStep = param.formStep, changeFormStep = param.changeFormStep, submitFirstStep = param.submitFirstStep, submitSecondStep = param.submitSecondStep, formErrors = param.formErrors, formRef = param.formRef, registrationStepsTitle = param.registrationStepsTitle, registrationSteps = param.registrationSteps, companiesTitle = param.companiesTitle, companiesLogo = param.companiesLogo, geekiesTitle = param.geekiesTitle, geekiesComments = param.geekiesComments, geekCommentsButton = param.geekCommentsButton, geekCommentsButtonIcon = param.geekCommentsButtonIcon, freePlatformBadge = param.freePlatformBadge, freePlatformTitle = param.freePlatformTitle, freePlatformButton = param.freePlatformButton, freePlatformButtonIcon = param.freePlatformButtonIcon;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "GeekHunter: Criar Perfil Gr\xe1tis"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPageHeader/* default */.Z, {
                headerLinks: header/* headerLinks */.Gb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(registrationForm, {
                formTitle: formTitle,
                formList: formList,
                formStep: formStep,
                changeFormStep: changeFormStep,
                submitFirstStep: submitFirstStep,
                submitSecondStep: submitSecondStep,
                formErrors: formErrors,
                formRef: formRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(candidates_registrationSteps, {
                registrationStepsTitle: registrationStepsTitle,
                registrationSteps: registrationSteps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(geekComments, {
                companiesTitle: companiesTitle,
                companiesLogo: companiesLogo,
                geekiesTitle: geekiesTitle,
                geekiesComments: geekiesComments,
                geekCommentsButton: geekCommentsButton,
                geekCommentsButtonIcon: geekCommentsButtonIcon,
                formRef: formRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(freePlatform, {
                freePlatformBadge: freePlatformBadge,
                freePlatformTitle: freePlatformTitle,
                freePlatformButton: freePlatformButton,
                freePlatformButtonIcon: freePlatformButtonIcon,
                formRef: formRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
        ]
    });
};
/* harmony default export */ var createFreeProfile = (CreateFreeProfile);

// EXTERNAL MODULE: ./src/lib/hooks/useSession.ts
var useSession = __webpack_require__(19713);
// EXTERNAL MODULE: ./src/lib/hooks/useGeekStorage/index.ts
var useGeekStorage = __webpack_require__(92511);
;// CONCATENATED MODULE: ./src/lib/hooks/useMarketingParams.ts

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var transformParam = function(param) {
    if (param) {
        if (typeof param === 'object') return param.join();
        if (typeof param === 'string') return param || undefined;
    }
    return undefined;
};
var useMarketingParams = function() {
    var ref = _slicedToArray((0,useGeekStorage/* useGeekStorage */.R)(), 1), geekStorage = ref[0];
    var ref1 = geekStorage || {}, utmSource = ref1.utmSource, utmMedium = ref1.utmMedium, utmTerm = ref1.utmTerm, utmCampaign = ref1.utmCampaign, fromReferral = ref1.fromReferral, firstReferer = ref1.firstReferer, deviceType = ref1.deviceType, slugPosition = ref1.slugPosition;
    return {
        utmSource: transformParam(utmSource),
        utmMedium: transformParam(utmMedium),
        utmTerm: transformParam(utmTerm),
        utmCampaign: transformParam(utmCampaign),
        fromReferral: transformParam(fromReferral),
        firstReferer: transformParam(firstReferer),
        deviceType: transformParam(deviceType),
        slugPosition: transformParam(slugPosition)
    };
};

// EXTERNAL MODULE: ./src/lib/constants/auth.ts
var auth = __webpack_require__(70333);
// EXTERNAL MODULE: ./src/lib/generated/graphql/index.tsx
var graphql = __webpack_require__(16402);
// EXTERNAL MODULE: ./src/components/atoms/themeProvider/index.tsx + 2 modules
var themeProvider = __webpack_require__(92015);
// EXTERNAL MODULE: ./src/components/atoms/nextSeo/index.tsx
var nextSeo = __webpack_require__(63198);
;// CONCATENATED MODULE: ./src/pages/criar-perfil-gratis/index.page.tsx


// @ts-ignore
/* eslint-disable @typescript-eslint/no-empty-interface */ 












function index_page_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function index_page_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function index_page_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function index_page_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function index_page_slicedToArray(arr, i) {
    return index_page_arrayWithHoles(arr) || index_page_iterableToArrayLimit(arr, i) || index_page_unsupportedIterableToArray(arr, i) || index_page_nonIterableRest();
}
function index_page_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return index_page_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return index_page_arrayLikeToArray(o, minLen);
}
var CreateFreeProfilePage = function() {
    var ref7 = (0,react.useState)(1), step = ref7[0], setStep = ref7[1];
    var ref1 = (0,react.useState)({
        email: '',
        acceptEmailNotifications: true
    }), candidateFirstStepData = ref1[0], setCandidateFirstStepData = ref1[1];
    var ref2 = (0,react.useState)([]), formErrors = ref2[0], setFormErrors = ref2[1];
    var formRef = (0,react.useRef)(null);
    var createSession = (0,useSession/* default */.Z)().createSession;
    var refetch = (0,graphql/* useCheckCandidateIsRegisteredQuery */.g0c)({
        skip: true
    }).refetch;
    var ref3 = index_page_slicedToArray((0,graphql/* useRegisterCandidateFirstStepMutation */.DP5)(), 1), registerCandidateFirstStepMutation = ref3[0];
    var ref4 = useMarketingParams(), utmSource = ref4.utmSource, utmMedium = ref4.utmMedium, utmTerm = ref4.utmTerm, utmCampaign = ref4.utmCampaign, fromReferral = ref4.fromReferral, firstReferer = ref4.firstReferer, deviceType = ref4.deviceType, slugPosition = ref4.slugPosition;
    var lastRenderedJob = slugPosition;
    var onSubmitFirstStep = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            var email, acceptEmailNotifications, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = param.email, acceptEmailNotifications = param.acceptEmailNotifications;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return refetch({
                            email: email
                        });
                    case 4:
                        res = _ctx.sent;
                        if (res.data.checkCandidateIsRegistered.isRegistered) {
                            setFormErrors([
                                {
                                    type: 'email',
                                    message: 'Email j\xe1 em uso na plataforma.'
                                }, 
                            ]);
                        } else {
                            setCandidateFirstStepData({
                                email: email,
                                acceptEmailNotifications: acceptEmailNotifications
                            });
                            setStep(2);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        setFormErrors([
                            {
                                type: 'email',
                                message: 'Falha ao comunicar-se com o sistema.'
                            }, 
                        ]);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function onSubmitFirstStep(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitSecondStep = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(data) {
            var ref, res, ref5, token, ref6;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return registerCandidateFirstStepMutation({
                            variables: {
                                email: candidateFirstStepData.email,
                                name: data.fullName,
                                password: data.password,
                                emailNotification: candidateFirstStepData.acceptEmailNotifications,
                                termsOfService: true,
                                utmSource: utmSource || 'direct',
                                utmMedium: utmMedium || '(none)',
                                utmTerm: utmTerm,
                                utmCampaign: utmCampaign || '',
                                fromReferral: fromReferral,
                                firstReferer: firstReferer,
                                deviceType: deviceType,
                                lastRenderedSlug: lastRenderedJob
                            }
                        });
                    case 3:
                        res = _ctx.sent;
                        if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.registerCandidateFirstStep.errors.length) === 0) {
                            ;
                            token = (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.registerCandidateFirstStep.authToken;
                            createSession(token, 'candidate', (0,auth/* AUTH_CANDIDATE_PATH */.J5)(token));
                        } else {
                            ;
                            setFormErrors([
                                {
                                    type: 'repeatPassword',
                                    message: (ref6 = res.data) === null || ref6 === void 0 ? void 0 : ref6.registerCandidateFirstStep.errors[0]
                                }, 
                            ]);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmitSecondStep(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var t = (0,useTranslation/* default */.Z)(translateNamespaces/* TRANSLATE_NAMESPACES.createProfile */.V.createProfile).t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(themeProvider/* ThemeProvider */.f, {
        colors: candidate/* candidateColorScheme */.h,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(nextSeo/* NextSeo */.P, {
                title: "GeekHunter: Criar Perfil Gr\xe1tis",
                description: "Dev, receba a proposta de emprego dos seus sonhos!",
                canonical: "https://www.geekhunter.com.br/criar-perfil-gratis"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(createFreeProfile, {
                /**
         * Create account form Props
         */ formTitle: t('formTitle'),
                formList: [
                    {
                        icon: ri_index_esm/* RiMoneyDollarCircleLine */.GdJ,
                        text: 'Saiba antes sobre remunera\xe7\xe3o e benef\xedcios das vagas'
                    },
                    {
                        icon: index_esm/* AiOutlineStar */.y5j,
                        text: 'Com um \xfanico cadastro voc\xea participa de todos os processos!'
                    }, 
                ],
                formErrors: formErrors,
                submitFirstStep: onSubmitFirstStep,
                submitSecondStep: onSubmitSecondStep,
                formStep: step,
                changeFormStep: setStep,
                formRef: formRef,
                /**
         * Registration steps props
         */ registrationStepsTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Cadastrar na GeekHunter ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " \xe9 simples 👉"
                    ]
                }),
                registrationSteps: [
                    {
                        step: '01',
                        title: 'Crie o seu perfil e deixe que as empresas encontrem voc\xea',
                        subTitle: '',
                        text: 'Importe seu perfil do LinkedIn e conte-nos sobre seu momento profissional, sua remunera\xe7\xe3o pretendida e seus interesses'
                    },
                    {
                        step: '02',
                        title: 'Demonstre interesse, receba convites e escolha a melhor proposta',
                        subTitle: '',
                        text: 'Logo ap\xf3s a aprova\xe7\xe3o do seu perfil, voc\xea j\xe1 est\xe1 apto a receber convites de entrevista. Demonstre interesse nas vagas e aumente suas chances'
                    },
                    {
                        step: '03',
                        title: 'Mantenha seu perfil atualizado e seja encontrado quando quiser',
                        subTitle: '',
                        text: 'Controle quando estar\xe1 vis\xedvel para as empresas: mantenha seu momento profissional, experi\xeancias e remunera\xe7\xe3o pretendida em dia'
                    }, 
                ],
                /**
         * Companies using geek and geek's feedback props
         */ companiesTitle: "As empresas que contratam nossos talentos de tecnologia",
                companiesLogo: [
                    {
                        src: '/companies/amazon.png',
                        alt: 'Amazon',
                        w: [
                            140
                        ],
                        h: [
                            40
                        ]
                    },
                    {
                        src: '/companies/centauro.png',
                        alt: 'Centauro',
                        w: [
                            140
                        ],
                        h: [
                            30
                        ]
                    },
                    {
                        src: '/companies/clickbus-white.png',
                        alt: 'Click Bus',
                        w: [
                            140
                        ],
                        h: [
                            40
                        ]
                    },
                    {
                        src: '/companies/esss-white.png',
                        alt: 'Esss',
                        w: [
                            140
                        ],
                        h: [
                            40
                        ]
                    },
                    {
                        src: '/companies/guiabolso.png',
                        alt: 'Guiabolso',
                        w: [
                            160
                        ],
                        h: [
                            40
                        ]
                    },
                    {
                        src: '/companies/meetime-white.png',
                        alt: 'MeeTime',
                        w: [
                            140
                        ],
                        h: [
                            40
                        ]
                    },
                    {
                        src: '/companies/mercadobitcoin.png',
                        alt: 'Mercado Bitcoin',
                        w: [
                            140
                        ],
                        h: [
                            50
                        ]
                    },
                    {
                        src: '/companies/rankmyapp.png',
                        alt: 'Rank My App',
                        w: [
                            140
                        ],
                        h: [
                            50
                        ]
                    },
                    {
                        src: '/companies/resultadosdigitais.png',
                        alt: 'Resultados Digitais',
                        w: [
                            140
                        ],
                        h: [
                            40
                        ]
                    },
                    {
                        src: '/companies/zup.png',
                        alt: 'Zup',
                        w: [
                            130
                        ],
                        h: [
                            50
                        ]
                    }, 
                ],
                geekiesTitle: "Por que profissionais amam a Geek? 💜",
                geekiesComments: [
                    {
                        image: {
                            src: '/geeks/geek1.webp',
                            alt: 'Guilherme Assemany'
                        },
                        name: 'Guilherme Assemany',
                        position: 'IT Manager',
                        comment: 'A GeekHunter me surpreendeu! A plataforma \xe9 bastante eficaz! Vale tamb\xe9m falar da aten\xe7\xe3o dos funcion\xe1rios. Todos que falaram comigo me trataram super bem e sempre acompanharam todo o processo de sele\xe7\xe3o, tirando d\xfavidas e ajudando no que fosse necess\xe1rio. Recomendo muito!'
                    },
                    {
                        image: {
                            src: '/geeks/geek2.webp',
                            alt: 'Daniela Cruz Tirado'
                        },
                        name: 'Daniela Cruz Tirado',
                        position: 'Software Engineer',
                        comment: 'Quando me cadastrei na GeekHunter j\xe1 comecei gostando muito da plataforma. Ela tem tudo que um profissional da \xe1rea de TI precisa mostrar para as empresas. Achei muito legal os feedbacks que enviam por email te atualizando sobre os processos seletivos e as dicas que d\xe3o para melhorar o perfil e ser mais visto entre as empresas.'
                    },
                    {
                        image: {
                            src: '/geeks/geek3.webp',
                            alt: 'Fabio Gunkel'
                        },
                        name: 'Fabio Gunkel',
                        position: 'IT Manager',
                        comment: 'Me interessei pelo modelo de contrata\xe7\xe3o e me cadastrei. As provas foram simples e diretas, mas sempre cobrando algum conte\xfado chave. Depois de aprovado n\xe3o demorou uma semana at\xe9 a primeira entrevista. Adorei o lugar e estou nele at\xe9 hoje. Recomendo e muito este servi\xe7o para todos os meus amigos da \xe1rea.'
                    }, 
                ],
                geekCommentsButton: "Criar meu perfil agora",
                geekCommentsButtonIcon: index_esm/* AiOutlineArrowRight */.mGl,
                /**
         * Free platform for devs session props
         */ freePlatformBadge: "Custa R$0 😱",
                freePlatformTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Sim, uma plataforma ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " 100% gratuita para ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " profissionais."
                    ]
                }),
                freePlatformButton: "Criar meu perfil agora",
                freePlatformButtonIcon: index_esm/* AiOutlineArrowRight */.mGl
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var index_page = (CreateFreeProfilePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,4617,6556,5937,1190,9161,8319,6830,6707,9914,3929,9892,401,9826,1930,9774,2888,179], function() { return __webpack_exec__(46299); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);